





// import enterpriseTemplate from "./templates/enterpriseTemplate.vue";
export default {
  name: "aiwen-findPassword-h5",
  components: {
    // enterpriseTemplate
  },
  data() {
    return {
      currentComponent: "enterpriseTemplate",
    };
  },
};
